const QuizTitles = Object.freeze({
        english: {
            radio: "Single/Multiple choice",
            radio_single: "Single choice",
            radio_multiple: "Multiple choice",
            matrix: "Matrix",
            ftb: "Fill in the blank",
            bool: "True or false",
            drag: "Sort into order",
            textarea: "Write short answer",
            select: "Select the part (3D)",
            isolated: "Name the part (3D)",
            draglabels: "Label the part (3D)",
            plopQuiz: "Drag and Drop (3D)",
            connect: "Connect the Bubbles",
            // fraction: "Pizza fractions",
            // ferris: "Ferris Wheel",
            // flashCard: "Flash Cards",
            // interactiveCar: "Interactive Car",
            embibeQuiz: "Embibe Quiz",
            dragDrop2d: "Drag and Drop (2D)",
            region: "Select the part (2D)"
        },
        hindi: {
            radio: "एकल/बहुविकल्पीय प्रश्न",
            radio_single: "एकल विकल्प प्रश्न",
            radio_multiple: "बहु विकल्पीय प्रश्न",
            matrix: "Matrix",
            ftb: "रिक्त स्थान भरें",
            bool: "सही अथवा गलत",
            drag: "सही क्रम में लगाएँ ",
            textarea: "संक्षिप्त उत्तर लिखें",
            select: "सही भाग को चुनें (3D)",
            isolated: "भाग का नाम बताएँ (3D)",
            draglabels: "भाग को लेबल करें (3D)",
            plopQuiz: "भाग को सही स्थान पर लगाएँ (3D)",
            connect: "अलग अलग भाग जोड़ें",
            // fraction: "पिज्जा फ्रैक्शन",
            // ferris: "फेरिस व्हील",
            // flashCard: "फ्लैश कार्ड",
            // interactiveCar: "इंटरैक्टिव कार",
            embibeQuiz: "Embibe क्विज",
            dragDrop2d: "ड्रैग कर सही जगह रखें(2D)",
            region: "सही स्थान चुनें "
        }
    }
);

module.exports = QuizTitles;